import { useMediaQuery } from "@mui/material";
import theme from "../theme/theme"; // Ensure this path points to your theme file

const useResponsive = () => {
  const options = { noSsr: true };
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"), options);
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"), options);
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"), options);

  return { isMobile, isTablet, isDesktop };
};
export default useResponsive;
